export default __webpack_public_path__ + "static/media/logo-light.ad6b793c.svg";